import TraderLayout from '../components/TraderLayout';
import {DepositWorkspace} from '../deposits/DepositWorkspace';
export default function TraderDeposit(){return <TraderLayout><DepositWorkspace/></TraderLayout>;}